{
  "assetContainerEvent": {
    "types": {
      "arrived": "已抵達",
      "arrivedWaiting": "已抵達/等候中",
      "loading": "裝貨中",
      "loadingComplete": "裝貨完成",
      "unloading": "卸貨中",
      "unloadingComplete": "卸貨完成",
      "readyForPickup": "可取貨",
      "departed": "已離開",
      "inoperable": "無法運作",
      "missing": "遺失",
      "inTransit": "移動中"
    }
  },
  "assetVisitYardEvent": {
    "Arrived": "已抵達",
    "Docked": "已停靠月台",
    "Parked": "已停放",
    "Unassigned": "未指派",
    "Dropped": "已放置",
    "Hooked": "已掛接",
    "Appointment Linked": "已連結預約",
    "Appointment Unlinked": "已取消連結預約",
    "Status Updated": "狀態更新"
  },
  "assetContainerTypes": {
    "trailer": "拖車",
    "container": "貨櫃",
    "oversized": "超大型",
    "chassis": "底盤車",
    "reefer": "冷凍貨櫃",
    "other": "其他"
  },
  "assetVisitTypes": {
    "live": "現場裝卸",
    "drop": "甩掛",
    "pickup": "掛接",
    "dropHook": "放置並掛接"
  },
  "assetVisitDirections": {
    "inbound": "進貨",
    "outbound": "出貨",
    "inboundAndOutbound": "進貨與出貨"
  },
  "loadTypeDirections": {
    "inbound": "進貨",
    "outbound": "出貨",
    "inOut": "進貨 & 出貨"
  },
  "altAssetVisitTypes": {
    "unknown": "未知"
  },
  "assetContainerStates": {
    "full": "滿載",
    "empty": "空櫃",
    "partiallyLoaded": "部分裝載"
  },
  "spotStatuses": {
    "open": "開放",
    "closed": "已關閉",
    "assigned": "已指派",
    "inTransit": "移動中",
    "reservedManual": "已保留",
    "reservedAutomated": "已保留",
    "unknown": "未知"
  },
  "spotTypes": {
    "parking": "停車",
    "docking": "停靠月台"
  },
  "labels": {
    "licensePlate": "車牌號碼",
    "dotNumber": "DOT 編號"
  },
  "messages": {
    "unknownCompany": "未知公司",
    "unhooked": "未掛接",
    "noInformationAvailable": "無可用資訊",
    "noVisitFound": "找不到到訪紀錄",
    "notInformed": "未提供",
    "waitingAssignment": "等候指派",
    "failedToLoadSpotDetails": "無法載入車位詳細資料",
    "retry": "重試",
    "blockedUntilSpotIsOpen": "在 {spot} 開放前已封鎖",
    "blockReasons": {
      "reservedByOther": "目的地車位已**保留**給**移動任務 #{taskNumber}**。",
      "reservedByOtherGeneric": "目的地車位已**保留**。",
      "destinationClosed": "目的地車位已**關閉**。",
      "destinationOccupied": "目的地車位已被其他資產**占用**。",
      "anotherAssetInTransitForDestination": "**{assetCode}** 已在移往此車位的途中。",
      "assetInTransitElsewhere": "資產已由其他移動任務移動中。"
    }
  }
}
